import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

export const Route = createFileRoute("/_staff/apps/_list/contract-and-cost")({
  component: ComingSoonCover,
});
